import { FollowButton, withFollow } from '@eventbrite/follow-organizer-ebui';
import isEmpty from 'lodash/isEmpty';
import React from 'react';
import '../../styles/followButton.scss';
import { FollowOrganizerProps } from '../../types';
import { dynaMount } from '../utils/mountComponent';
import { numberFormatter } from '../utils/utils';

const FOLLOW_ORGANIZER_MINI_SIZE = 'mini';
const FOLLOW_ORGANIZER_HERO_ID = 'listings-root__follow-organizer_hero';
const FOLLOW_ORGANIZER_EXPIRED_ID = 'listings-root__follow-organizer_expired';

const EnhancedFollowButtton = withFollow(FollowButton);

const followOrganizerHeroFollowCountRender = (
    followCount: string,
): JSX.Element => {
    const followCountNumber = parseInt(followCount, 10);
    const followCountFormatted = numberFormatter(followCountNumber);

    return (
        <div className="follow-organizer__follow-count">
            {`${followCountFormatted} followers`}`
        </div>
    );
};

export const FollowOrganizerWidget: React.FunctionComponent<
    FollowOrganizerProps
> = (props) => {
    const { organizers, size, renderFollowCount } = props;

    return (
        <EnhancedFollowButtton
            isOnlyButton={true}
            organizerId={organizers[0]}
            size={size}
            renderFollowCount={renderFollowCount}
        />
    );
};

const FollowOrganizerHero = (props: FollowOrganizerProps) =>
    dynaMount(
        {
            Component: FollowOrganizerWidget,
            containerId: FOLLOW_ORGANIZER_HERO_ID,
        },
        {
            ...props,
            size: FOLLOW_ORGANIZER_MINI_SIZE,
            renderFollowCount: followOrganizerHeroFollowCountRender,
        },
    );

const FollowOrganizerExpired = (props: FollowOrganizerProps) =>
    dynaMount(
        {
            Component: FollowOrganizerWidget,
            containerId: FOLLOW_ORGANIZER_EXPIRED_ID,
        },
        props,
    );

const FollowOrganizerMount = (props: FollowOrganizerProps): JSX.Element => (
    <>
        <FollowOrganizerHero {...props} />
        <FollowOrganizerExpired {...props} />
    </>
);

const FollowOrganizerRoot = (
    props: FollowOrganizerProps,
): JSX.Element | null => {
    if (isEmpty(props.organizerId)) {
        return null;
    }

    return <FollowOrganizerMount {...props} />;
};

export default FollowOrganizerRoot;
